import LinearProgress from '@mui/material/LinearProgress';
import { useQuery } from '@tanstack/react-query';
import React, { createContext, useContext } from 'react';
import { fetchQRCodesData } from '../../api/mobileapi';
import { Settings } from '../../api/types';
import { AdamsError } from '../../utils/errors';
import { GlobalError } from '../GlobalError/GlobalError';
import { useTranslations } from '../Translations/TranslationsProvider';

interface EndpointsDataContextValue {
    endpointsData: Settings;
}

const EndpointsDataContext = createContext<EndpointsDataContextValue | undefined>(undefined);

interface EndpointsDataProviderProps {
    children: React.ReactNode;
}

export const EndpointsDataProvider: React.FC<EndpointsDataProviderProps> = ({ children }) => {
    const { translations } = useTranslations();
    const { data, error, isLoading } = useQuery<Settings, AdamsError>(['endpointsData'], () => fetchQRCodesData());

    if (error) {
        return <GlobalError error={error} translations={translations} />;
    }

    if (isLoading || !data) return <LinearProgress />;

    return (
        <EndpointsDataContext.Provider value={{ endpointsData: data }}>
            <>{children}</>
        </EndpointsDataContext.Provider>
    );
};

export const useEndpointsData = () => {
    const value = useContext(EndpointsDataContext);
    if (value === undefined) {
        throw new Error();
    }
    return value;
};
